module.exports = class RegistrationService {

  static $inject =[
    '$http',
  ];

  constructor($http) {
    this.$http = $http;
    this.initializeStates();
  }

  initializeStates() {
    this.states = {
      register: {
        init: true,
        sameEmail: false,
        confirmed: false,
        sameClinic: false,
        maskedEmail: false,
        clinicAcceptsNewPatients: false,
        activationEmailSent: false,
      },
      forgotPassword: {
        init: true,
        emailSent: false,
        notFound: false,
        expired: false,
      },
    };
  }

  register(model, locale, withMandatoryFields) {
    let params = {
      group_id: model.groupId,
      email: model.email,
      locale,
    };

    params = Object.assign(params, this.preparePatientForRegister(model, withMandatoryFields, model.manitoba));

    if (model.linkedPatient && model.linkedPatient.hin) {
      const linkedPatient = this.preparePatientForRegister(model, withMandatoryFields, model.manitoba, true);
      if (model.linkedPatient.useSameContactInfo && withMandatoryFields) {
        linkedPatient.profile = _.cloneDeep(params.profile);
      }

      params.linked_patient = linkedPatient;
    }

    return this.$http.post('/api/v2/patients', params);
  }

  preparePatientForRegister(model, withMandatoryFields, manitoba, linkedPatient) {
    const patient = linkedPatient ? model.linkedPatient : model.mainPatient;

    const preparedPatient = {
      gender: patient.gender,
      first_name: patient.firstName,
      last_name: patient.lastName,
      birthdate: patient.birthdate,
      hin: manitoba ? model.hin : patient.hin.replace(/\s/g, '').toUpperCase(),
      hin_expiration_year: withMandatoryFields ? parseInt(patient.hinExpirationYear) : undefined,
      hin_expiration_month: withMandatoryFields ? parseInt(patient.hinExpirationMonth) : undefined,
    };

    if (withMandatoryFields) {
      preparedPatient.profile = {
        city: patient.city,
        street: '',
        postal_code: '',
        territory: '',
        contact_methods: [{
          kind: patient.phoneKind,
          number: patient.phone,
        }],
      };
    }

    return preparedPatient;
  }

  resetPassword(model) {
    return this.$http.post('/api/v2/patients/reset_password', {
      group_id: model.groupId,
      email: model.email,
    });
  }

  hasErrors(ngModel) {
    if (ngModel == null) {
      return false;
    }
    return ((ngModel.$touched || ngModel.$$parentForm.$submitted) && ngModel.$invalid);
  }

  canSubmit(form) {
    if (!form) {
      return false;
    }
    if (form.$error && (form.$error.required != null) && (form.$error.required.length > 0)) {
      return false;
    }
    return true;
  }
};



// WEBPACK FOOTER //
// ./signin/services/registration-service.js